module.exports = __webpack_public_path__ + "img/20bd55c.svg";